/* eslint-disable no-console */
export const consoleLogger = {
    info: (...args) => console.info(...args),
    warn: (...args) => console.warn(...args),
    error: (...args) => console.error(...args),
};
//# sourceMappingURL=console-logger.js.map